module.exports = __webpack_public_path__ + "static/media/Heatersbanner.cc33b6df.jpg";